import React from 'react';
import resume from '../data/resume';

const Header = () => {
  const headerStyle = {
    textAlign: 'left',
    marginBottom: '20px'
  };

  const promptStyle = {
    fontSize: '14px',
    color: '#00FF00',
    margin: '0 0 5px 0',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const nameStyle = {
    fontSize: 'clamp(20px, 7vw, 28px)',
    fontWeight: 'bold',
    margin: '0 0 8px 0',
    letterSpacing: 'clamp(1px, 0.8vw, 3px)',
    color: '#00FF00',
    textShadow: '0 0 10px rgba(0,255,0,0.8)',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace',
    wordBreak: 'break-word'
  };

  const titleStyle = {
    fontSize: 'clamp(10px, 3vw, 16px)',
    margin: '0 0 5px 0',
    color: '#00FF00',
    letterSpacing: '1px',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const asciiContainerStyle = {
    overflowX: 'auto',
    whiteSpace: 'pre',
    backgroundColor: 'transparent',
    padding: '5px 0'
  };

  const asciiStyle = {
    fontSize: 'clamp(6px, 1.9vw, 12px)',
    color: '#00FF00',
    margin: '10px 0',
    lineHeight: '1.2',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace',
    display: 'inline-block'
  };
  

  return (
    <header style={headerStyle}>
      <div style={promptStyle}>$ whoami</div>
      <h1 style={nameStyle}>{resume.name.toUpperCase()}</h1>
      <p style={titleStyle}>{resume.title.toUpperCase()}</p>
      <div style={asciiContainerStyle}>
        <pre style={asciiStyle}>
          ┌──────────────────────────────────────────────────────┐<br/>
          │  ███████╗ █████╗ ██╗   ██╗███████╗ █████╗ ███╗   ██╗ │<br/>
          │  ██╔════╝██╔══██╗██║   ██║╚══███╔╝██╔══██╗████╗  ██║ │<br/>
          │  █████╗  ███████║██║   ██║  ███╔╝ ███████║██╔██╗ ██║ │<br/>
          │  ██╔══╝  ██╔══██║╚██╗ ██╔╝ ███╔╝  ██╔══██║██║╚██╗██║ │<br/>
          │  ██║     ██║  ██║ ╚████╔╝ ███████╗██║  ██║██║ ╚████║ │<br/>
          │  ╚═╝     ╚═╝  ╚═╝  ╚═══╝  ╚══════╝╚═╝  ╚═╝╚═╝  ╚═══╝ │<br/>
          └──────────────────────────────────────────────────────┘
        </pre>
      
      </div>
    </header>
  );
};

export default Header;
